import React, {Fragment, useState} from "react";
import { SmartErrorDiv } from "./SmartErrorDiv";
import {EyeFill, EyeSlashFill} from "react-bootstrap-icons";
import {validatePassword} from "root/Login/passwordValidationHelper";

import './FormInputPassword.scss' ;

export const PasswordRules = {
    MIN_LENGTH: "minLength",
    REQUIRE_UPPERCASE: "requireUppercase",
    REQUIRE_LOWERCASE: "requireLowercase",
    REQUIRE_NUMERIC_CHAR: "requireNumericChar",
    REQUIRE_SPECIAL_CHAR: "requireSpecialChar",
};

export const defaultRules = [
    { type: PasswordRules.MIN_LENGTH, value: 8 },
    { type: PasswordRules.REQUIRE_UPPERCASE },
    { type: PasswordRules.REQUIRE_LOWERCASE },
    { type: PasswordRules.REQUIRE_NUMERIC_CHAR },
    // { type: PasswordRules.REQUIRE_SPECIAL_CHAR },
];

export const minRules = [
    { type: PasswordRules.MIN_LENGTH, value: 8 },
];

/**
 * react-hook-form User input field to implement password input and validation
 *
 * Implements a user input with optional hide/reveal password option, and
 *
 * @property string schema Optional named PasswordValidationSchema (see passwordValidationHelper), defaults to 'basic'
 *
 * @example
 *
 * <FormInputPassword schema='basic'
 *                     iconColor={iconColor}
 *                     readOnly={false}
 *                     label='Password'
 *                     placeHolder='Password'
 *                     sectionName={sectionName}
 *                     name={'password'}
 *                     register={register}
 *                     required={true}
 *                     maxLength={100}
 *                     autocomplete='off'
 *                     formErrors={formErrors}/>>
 */
const FormInputPassword = ( { register, iconColor, pattern, readOnly, sectionName, name, rules = [], schema = 'basic', className, formErrors, maxLength, required, placeHolder, autocomplete } ) =>
{
    const classText = className === undefined ? "form-control" : '' ;

    const [ type, setType ] = useState ( false ) ;

    const togglePasswordView = () =>
    {
        setType ( (type) => !type ) ;
    }

    const typeText = type ? 'text' : 'password' ;
    const eye = type ? <EyeSlashFill/> : <EyeFill/>

    const iconStyle = iconColor === undefined ? {} : { color: iconColor} ;

    const checkPasswordRules = ( value ) =>
    {
        const checkResult = validatePassword(value, schema) ;

        if ( checkResult.valid === true )
        {
            return true ;
        }

        return checkResult.errors[0] ;
    }

    return (
        <Fragment>
            <div className="password-box">
                <input readOnly={readOnly}
                       autoComplete={autocomplete}
                       placeholder={placeHolder}
                       type={typeText}
                       className={classText} {...register(sectionName + '.' + name, {
                    required: required,
                    maxLength: maxLength,
                    pattern: pattern,
                    validate: checkPasswordRules
                })} />
                <i className='bi' onClick={togglePasswordView} style={iconStyle}>{eye}</i>
            </div>
            <SmartErrorDiv sectionName={sectionName} name={name} maxLength={maxLength} formErrors={formErrors}/>
        </Fragment>
)
}

export {
    FormInputPassword
} ;
